import { updateContactsFn } from 'api'
import { useMutation, useQueryClient } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

export function useUpdateContact() {
  const [t] = useTranslation()
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  return useMutation(updateContactsFn, {
    onError: (e) => {
      toast.error(t('error.default'))
    },
    onSuccess: (a, b) => {
      queryClient.invalidateQueries(['contacts'])

      navigate(-1)
      toast.success(t('modal.editContact.editSuccess'))
    },
  })
}
